import Box from '@mui/material/Box';
import React, {useEffect, useState} from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import axios from 'axios';
import {config} from '../../common/config/config';
import Paper from '@mui/material/Paper';
import {constance} from '../../common/constance/constance';
import {common} from '../../common/common';
import {styles} from '../../common/style';
import {DateTime} from 'luxon';
import {isMobile} from 'react-device-detect';
import CultureForumReplyDialog from './CultureForumReplyDialog';
import {User} from '../../interface/user.interface';
import {useSelector} from "react-redux";
import {RootState} from "../../reducer";

export interface CultureForumReplayState {
    forumList: Forum[],
    openReply: boolean,
    selectedForum: Forum,
    replyList: Reply[]
}

export interface Reply {
    _id: string,
    user: User,
    content: string,
    createdAt: string,
}

interface Forum {
    _id: string,
    number: number,
    title: string,
    time: string,
    user: User,
    thumbnail: string,
    fileNameList: string[],
    replyCount: number
}

export default function CultureForumReplay() {
    console.log(`[CultureForumReplay]`);
    const commonData = useSelector((state: RootState) => state.commonData);

    const [state, setState] = useState<CultureForumReplayState>({
        forumList: [],
        openReply: false,
        selectedForum: {
            _id: '', replyCount: 0,
            fileNameList: [], number: 0, thumbnail: '', time: '', title: '',
            user: {_id: '', admin: false, departmentCode: '', departmentName: '', id: '', name: ''},
        },
        replyList: [],
    });

    useEffect(() => {
        getData();
    }, []);

    function getData() {
        axios.get(constance.api.getCultureForum).then(value => {
            console.log(value);
            setState({
                ...state,
                forumList: value.data.data,
            });
        }).catch(reason => {
            common.alert('문화포럼 목록 조회 실패', reason.message, 'error');
        });
    }

    function makeDateTime(timeStr: string) {
        let time: Date = new Date(timeStr);
        let dateFormat = DateTime.fromMillis(time.getTime()).toFormat('yyyy년 MM월 dd일');
        dateFormat += ' ' + common.getWeekDayText(DateTime.fromMillis(time.getTime()).weekday, isMobile);

        return dateFormat;
    }

    function handleDownload(fileList: string[]) {

    }

    function openReplyBox(forum: Forum) {

        /* 리플 리스트 조회 */
        axios.get(constance.api.getReplyList, {
            params: {
                _id: forum._id,
            },
        }).then(value => {
            setState({
                ...state,
                openReply: true,
                selectedForum: forum,
                replyList: value.data.data,
            });
        }).catch(reason => {
            console.log(reason);
        });

    }

    function handleDeleteForumReplay(forum: Forum) {
        /* 댓글 삭제 */
        axios.post(constance.api.deleteForumReplay, {
            params: {
                _id: forum._id,
            },
        }).then(value => {
            getData();
        }).catch(reason => {
            console.log(reason);
        });
    }

    return (
        <>
            <Box sx={{display: 'flex', justifyContent: 'center', p: 1}}>
                <Stack sx={{
                    width: 1,
                    maxWidth: config.maxWidth,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center', mb: 2,
                }}>
                    {
                        state.forumList.map((forum, index) => {
                            return (
                                <Paper key={index}
                                       variant={'elevation'}
                                       elevation={3}
                                       sx={{
                                           display: 'flex', alignItems: 'flex-start',
                                           mt: isMobile ? 1 : 3, width: 1, p: isMobile ? 1 : 2, pl: isMobile ? 1 : 4,
                                       }}>
                                    <Stack sx={{width: isMobile ? 0.5 : 0.6, pr: isMobile ? 1 : 4}}>
                                        <Box sx={{
                                            display: 'flex',
                                            position: 'relative',
                                            alignItems: 'center',
                                            width: 1
                                        }}>
                                            <Typography variant={isMobile ? 'h6' : 'h4'}
                                                        sx={{color: styles.fontColor.secondary, fontWeight: 700}}>
                                                {`제 ${forum.number} 회`}
                                            </Typography>
                                            <Button variant={"outlined"}
                                                    color={"error"}
                                                    onClick={() => handleDeleteForumReplay(forum)}
                                                    sx={{
                                                        display: commonData.user.admin ? 'block' : 'none',
                                                        position: 'absolute',
                                                        right: 0
                                                    }}>
                                                <Typography variant={'subtitle1'}
                                                            sx={{color: styles.deleteColor, fontWeight: 700}}>
                                                    {`삭제`}
                                                </Typography>
                                            </Button>
                                        </Box>
                                        {/* 주제 */}
                                        <Box sx={{width: 1, display: 'flex', mt: isMobile ? 2 : 4}}>
                                            <Typography variant={isMobile ? 'subtitle2' : 'h6'}
                                                        sx={{
                                                            color: styles.fontColor.main,
                                                            fontWeight: 500,
                                                            width: 0.25
                                                        }}>
                                                {`주제`}
                                            </Typography>
                                            <Typography variant={isMobile ? 'subtitle2' : 'h6'}
                                                        sx={{color: styles.fontColor.secondary, width: 0.75, ...styles.textKeepAll}}>
                                                {`${forum.title}`}
                                            </Typography>
                                        </Box>

                                        <Divider sx={{mt: isMobile ? 1 : 2, mb: isMobile ? 1 : 2}}/>
                                        {/* 발표일 */}
                                        <Box sx={{width: 1, display: 'flex'}}>
                                            <Typography variant={isMobile ? 'subtitle2' : 'h6'}
                                                        sx={{
                                                            color: styles.fontColor.main,
                                                            fontWeight: 500,
                                                            width: 0.25
                                                        }}>
                                                {`발표일`}
                                            </Typography>
                                            <Typography variant={isMobile ? 'subtitle2' : 'h6'}
                                                        sx={{color: styles.fontColor.secondary, width: 0.75}}>
                                                {`${makeDateTime(forum.time)}`}
                                            </Typography>
                                        </Box>

                                        <Divider sx={{mt: isMobile ? 1 : 2, mb: isMobile ? 1 : 2}}/>
                                        {/* 발표일 */}
                                        <Box sx={{width: 1, display: 'flex'}}>
                                            <Typography variant={isMobile ? 'subtitle2' : 'h6'}
                                                        sx={{
                                                            color: styles.fontColor.main,
                                                            fontWeight: 500,
                                                            width: 0.25
                                                        }}>
                                                {`발표자`}
                                            </Typography>
                                            <Typography variant={isMobile ? 'subtitle2' : 'h6'}
                                                        sx={{color: styles.fontColor.secondary, width: 0.75}}>
                                                {`${forum.user.departmentName} ${forum.user.name}`}
                                            </Typography>
                                        </Box>

                                        <Divider sx={{mt: isMobile ? 1 : 2, mb: isMobile ? 1 : 2}}/>

                                        {/* 댓글달기, 발표자료 내려받기 */}
                                        <Box sx={{width: 1, display: 'flex'}}>
                                            <Box sx={{width: 0.5, pr: isMobile ? 1 : 2}}>
                                                <Button variant={'outlined'} color={'success'}
                                                        onClick={() => openReplyBox(forum)}
                                                        sx={{width: 1, p: isMobile ? 1 : 1}}>
                                                    <Box sx={{
                                                        width: 1,
                                                        display: 'flex',
                                                        justifyContent: 'flex-start',
                                                        alignItems: 'center'
                                                    }}>
                                                        <img src={'/images/reply-icon.png'} alt={'리플 아이콘'}
                                                             style={{width: isMobile ? 20 : 35}}/>
                                                        <Box sx={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            flexGrow: 1
                                                        }}>
                                                            <Typography variant={isMobile ? 'subtitle2' : 'h6'}
                                                                        sx={{color: styles.fontColor.secondary}}>
                                                                {`댓글`}
                                                            </Typography>
                                                            <Typography variant={isMobile ? 'subtitle2' : 'h6'}
                                                                        sx={{
                                                                            display: {
                                                                                xs: 'none',
                                                                                sm: 'none',
                                                                                md: 'flex'
                                                                            },
                                                                            color: styles.fontColor.secondary,
                                                                            ml: 1,
                                                                        }}>
                                                                {` [${forum.replyCount}]`}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Button>
                                            </Box>
                                            <Box sx={{width: 0.5, pl: isMobile ? 1 : 2}}>
                                                <Button variant={'outlined'} color={'primary'}
                                                        onClick={() => handleDownload(forum.fileNameList)}
                                                        sx={{width: 1, p: isMobile ? 1 : 1}}>
                                                    <Box sx={{
                                                        width: 1,
                                                        display: 'flex',
                                                        justifyContent: 'flex-start',
                                                        alignItems: 'center'
                                                    }}>
                                                        <img src={'/images/download-pdf.png'} alt={'리플 아이콘'}
                                                             style={{width: isMobile ? 20 : 35}}/>
                                                        <Typography variant={isMobile ? 'subtitle2' : 'h6'}
                                                                    sx={{width: 1, color: styles.fontColor.secondary}}>
                                                            <a href={`${forum.fileNameList[0]}`}
                                                               style={{
                                                                   textDecoration: 'none',
                                                                   color: styles.fontColor.secondary
                                                               }}
                                                               download={true}
                                                            >{isMobile ? '자료' : '발표자료'}</a>
                                                        </Typography>
                                                    </Box>
                                                </Button>
                                            </Box>
                                        </Box>

                                    </Stack>
                                    <Box sx={{
                                        display: 'flex', justifyContent: 'center', alignItems: 'center',
                                        width: isMobile ? 0.5 : 0.4, height: 1,
                                        p: isMobile ? 1 : 2,
                                    }}>
                                        <img alt={''}
                                             style={{
                                                 maxHeight: 250,
                                                 maxWidth: '100%',
                                                 boxShadow: '2px 2px 2px #b5b5b5',
                                                 borderRadius: '12px',
                                             }}
                                             src={`${forum.thumbnail}`}/>
                                    </Box>
                                </Paper>
                            );
                        })
                    }
                </Stack>
                {CultureForumReplyDialog(state, setState)}
            </Box>
        </>
    );
}